import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'exposure-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '30px',
    },
    'exposure--client-selector': {
      width: '250px',
    },
    'exposure--input': {
      width: '80%',
      marginBottom: '20px',
    },
    'fading-container': {
      animation: 'fadeIn ease 2s',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
    },
    'exposure--buttons-container': {
      display: 'flex',
      maxWidth: '250px',
      width: '200px',
      justifyContent: 'space-between',
    },
    'exposure--image-title': {
      margin: '20px 0',
    },
    'exposure--title': {
      marginBottom: '20px',
      textAlign: 'center',
    },
    'exposure--tooltip': {
      minWidth: '50%',
    },
    'exposures--thoughts-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: '25px',
    },
    'exposure--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: '20px',
    },
    'exposures--question-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    'exposures--arrow-icon': {
      marginTop: '20px',
    },
    'exposures--generate-row': {
      display: 'flex',
      flexWrap: 'wrap',
      flexFlow: 'wrap',
      justifyContent: 'space-between',
      marginBottom: '15px',
    },
    'exposures--generate-row-button': {
      margin: '7px 0',
    },
    'exposures--situation-row': {
      display: 'flex',
      flexFlow: 'wrap',
      flexWrap: 'wrap',
    },
    'exposures--move-buttons': {
      display: 'flex',
      flexDirection: 'column',
      marginLeft: '10px',
    },
    'exposures--move-row': {
      display: 'flex',
      alignItems: 'center',
    },
    'exposures--is-generating-row': {
      display: 'flex',
      justifyContent: 'center',
    },
    'exposure--back-row': {
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '32px',
      display: 'flex',
      alignItems: 'center',
    },
    'exposure--generate-row': {
      'display': 'flex',
      'flexDirection': 'column',
      'alignItems': 'flex-start',

      '@media screen and (max-width: 700px)': {
        alignItems: 'center',
      },
    },
    'exposure--generate-row--or': {
      'margin': '5px 0 5px 80px',

      '@media screen and (max-width: 700px)': {
        margin: '5px 0',
      },
    },
    'exposure--stopwatch': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 0 20px 0',
      flexWrap: 'wrap',
    },
    'exposure--sud-row': {
      display: 'flex',
      alignItems: 'baseline',
      fontWeight: 600,
    },

    'exposure-upload-card': {
      /*
       * THE CONTAINER, NOT THE THUMBNAILS, WAS THE PROBLEM (founder, portal testing 2026-09-10:
       * "when we have multiple images (e.g. from mobile), portal displays them in one column, which
       * is not a good use of space that pushes the rest of it").
       *
       * `listType="picture-card"` was already set and antd's picture-card list already wraps — but
       * this wrapper was pinned to 208px, exactly ONE thumbnail wide, so there was never room for a
       * second item on a row and every image took a line of its own. Widening the container lets the
       * existing wrap do its job; each item keeps its 208px, so a single image looks unchanged.
       */
      'width': '100%',
      '& .ant-upload-select': {
        width: '208px !important',
        height: '208px !important',
      },

      '& .ant-upload-list-picture-card': {
        'display': 'flex',
        'flexWrap': 'wrap',
        'gap': '8px',
        '@media screen and (max-width: 700px)': {
          justifyContent: 'center',
          textAlign: 'center',
        },
      },
      '& .ant-upload-list-item-container': {
        width: '208px !important',
        height: '208px !important',
      },
      '& .ant-upload-list-item': {
        width: '208px !important',
        height: '208px !important',
      },
      '& .ant-upload-list-item-thumbnail': {
        width: '190px !important',
        height: '190px !important',
      },
    },
    'exposure-upload-card__upload-icon': {
      marginRight: '8px',
    },
    'exposure-start-button': {
      marginTop: '20px',
    },
  };
});
export default useStyles;
